<template>
  <footer>
    <!-- <h4>ATLASCAP</h4> -->
    <div class="mylogo">
      <img :src="logo" alt="" />
    </div>
    <h4>公司地址</h4>
    <p class="text">北京市朝阳区东三环北路38号院1号&nbsp;泰康金融大厦3616</p>
    <h4>联系我们</h4>

    <div class="box">
      <p class="text">
        商务合作：<a href="mailto:business@atlascap.com.cn"
          >business@atlascap.com.cn</a
        >
      </p>
      <p class="text">
        递送商业计划书：
        <a href="mailto:bp@atlascap.com.cn">bp@atlascap.com.cn</a>
      </p>
    </div>

    <p class="text">
      人才招纳：
      <a href="mailto:hr@atlascap.com.cn">hr@atlascap.com.cn</a>
    </p>
    <p class="text">
      联系电话：
      <a>010-65081864</a>
    </p>

    <p class="callme">
      Copyright © 2020 Atlas. All Rights Reserved. 浙ICP备17036572号
    </p>

    <div class="right">
      <img :src="erewei" alt="" />
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      logo: require("../../images/footerlogo.png"),
      erewei: require("../../images/headlogo.jpg")
    };
  },
  computed: {
    ...mapGetters({
      language: "getType"
    })
  }
};
</script>

<style lang="less" scoped>
footer {
  width: 100%;
  background: #ff8f3c;
  box-sizing: border-box;
  padding: 0.29rem 0.43rem;
  background: rgba(255, 143, 60, 1);
  background-image: url("../../images/footer.png");
  background-size: 2.04rem 2.92rem;
  background-position: bottom right;
  background-repeat: no-repeat;
  box-sizing: border-box;
  position: relative;

  .text {
    font-size: 0.2rem;
    color: white !important;
    line-height: 0.4rem;
    a {
      color: #fff !important;
    }
  }
  .box {
    width: 4.7rem;
  }
  h4 {
    font-size: 0.28rem;
    margin: 0.3rem 0;
    color: white !important;
    font-weight: normal;
  }
  .callme {
    margin-top: 0.4rem;
    font-size: 0.2rem;
    color: #ffff !important;
    opacity: 0.48;
    font-family: PingFang SC;
    font-weight: 300;
    opacity: 0.48;
    text-align: center;
    white-space: nowrap;
  }
  .right {
    width: 1.29rem;
    height: 1.29rem;

    position: absolute;
    bottom: 1.38rem;
    right: 0.42rem;
    background-color: #ff6a00;
    img {
      width: 100%;
      height: 100%;
    }
    display: flex;
    flex-direction: column-reverse;
    p {
      font-size: 0.16rem;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      margin-bottom: 0.12rem;
    }
    a {
      color: #fff;
    }
  }
  .mylogo {
    width: 2.09rem;
    height: 0.6rem;
    img {
      width: 100%;
      height: 100%;
    }
    background-size: 100% 100%;
    margin-bottom: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/mycomoponet/footer.vue